module.exports = __webpack_public_path__ + "static/media/social-fb.b651f7e2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/social-fb.svg
// module id = 347
// module chunks = 0